import { useEffect, useState } from 'react';
import { COOKIES, getCookie } from 'utils/helpers';

export function useIsIpad() {
  const [isIpad, setIsIpad] = useState(false);

  // habia un error con appmode que lanzaba errores de hidratación. Nunca intentar saber el valor de una cookie si no sabemos si el código solo se ejecuta en el cliente.
  useEffect(() => {
    const isAppMode = getCookie(COOKIES.APP_IPAD) === 'true';
    setIsIpad(isAppMode);
  }, []);

  return isIpad;
}
